import { REPORTS } from '@/constants/reports.constants';

export const REPORT_DEFAULT_VALUES = {
  attachments: [],
  report_name: '',
  report_type_id: null,
  report_frequency_id: 1
};

export const FREQUENCY_OPTIONS = [
  {
    id: 1,
    label: 'Daily'
  },
  {
    id: 2,
    label: 'Weekly'
  },
  {
    id: 3,
    label: 'Monthly'
  }
];

export const REPORT_TYPES = [
  {
    id: 1,
    label: REPORTS.MDR
  },
  {
    id: 2,
    label: REPORTS.EXEC
  },
  {
    id: 3,
    label: REPORTS.VMP
  },
  {
    id: 4,
    label: REPORTS.EDR
  }
];

export default REPORT_TYPES;
